// extracted by mini-css-extract-plugin
export var badge = "PlanSelection-module__badge___ZsS9O";
export var compareLink = "PlanSelection-module__compareLink___PIs5B";
export var description = "PlanSelection-module__description___YFOAg";
export var peakRow = "PlanSelection-module__peakRow___SGx7x";
export var peakSelected = "PlanSelection-module__peakSelected___hCnij";
export var planContainer = "PlanSelection-module__planContainer___EP48B";
export var planSelectionWrapper = "PlanSelection-module__planSelectionWrapper___pD_74";
export var plusSelected = "PlanSelection-module__plusSelected___ShtYu";
export var topRow = "PlanSelection-module__topRow___iYH3R";